export enum TeamMemberRole {
  MANAGER = 'MANAGER',
  MEMBER = 'MEMBER',
  PORTFOLIO_FEATURE = 'feat-portfolio',
  GUEST = 'GUEST',
  PRO = 'pro',
  PRO_STARTER = 'pro_starter',
  PRIME = 'prime',
}
